import { SharedAppSettings } from '@luggagehero/shared/app-settings/data-access';

export const DefaultAppSettings: Partial<SharedAppSettings> = {};
